export default __webpack_public_path__ + "tmp_src/components/FilterPills/FilterPills.css.liquid";